import HeroSection from './components/HeroSection';
import FeaturedComics from './components/FeaturedComics';
import CategoryNav from './components/CategoryNav';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '布丁漫画网',
            url: 'https://budingmanhua.com',
            description:
              '布丁漫画网提供布丁漫画全集下拉式连续阅读，无需翻页即可畅享完整漫画内容。布丁漫画下拉式免费看韩漫、日漫、国漫大全。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://budingmanhua.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '布丁漫画网',
            url: 'https://budingmanhua.com',
            description:
              '布丁漫画网 - 专注下拉式连续阅读的漫画平台，提供韩漫、日漫、国漫等全类型漫画免费在线观看。',
          }),
        }}
      />
      <main>
        <HeroSection />
        <FeaturedComics />
        <CategoryNav />
        <LatestUpdates />
        <FAQSection />
      </main>
    </>
  );
}